class DropAHintForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.status = this.querySelector('.drop-a-hint-form__status');

    if (!this.form) {
      return;
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  onSubmit(event) {
    event.preventDefault();

    // TODO: wire this up to the Attentive-backed "drop a hint" event/journey once that endpoint exists.
    // Until then, no email is actually sent — surface that clearly instead of a fake success state.
    if (this.status) {
      this.status.textContent = this.dataset.pendingMessage || 'This form is not connected yet — check back soon!';
      this.status.hidden = false;
    }
  }
}

if (!window.customElements.get('drop-a-hint-form')) {
  window.customElements.define('drop-a-hint-form', DropAHintForm);
}
